import { DataTable, Dialog, Loader } from "@/components";
import useOutstandingDueDialog from "./useIncidentDialog";
import { OutstandingDueDialogProps } from "./types";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui";
import { incidentTabs } from "../consts";

const OutstandingDueDialog = ({
  open,
  setOpen,
  selectedRow,
}: OutstandingDueDialogProps) => {
  const { columns, incidentList, isDocLoading, setPageNumber, setPageSize,
    pageNumber, pageSize, activeTab, onTabChange, sorting, setSorting
  } = useOutstandingDueDialog({ selectedRow });
  
  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={<div className="text-2xl font-bold text-primary">
          {"Incidents"}
          <div className="h-1 w-[30%] bg-primary rounded-full" />
        </div>
      }
      contentClassName="lg:!max-w-[700px] lg:!w-[700px]"
    >
      <Tabs
        value={activeTab}
        onValueChange={onTabChange}
        className="w-full"
      >
        <TabsList className="gap-x-4 bg-transparent">
          {incidentTabs.map((tab) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className="data-[state=active]:shadow-none hover:cursor-pointer text-gray-400 hover:text-primary px-0 border-0 shadow-none data-[state=active]:rounded-none data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-primary"
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value={activeTab}>
          {isDocLoading ? <Loader /> :
            <DataTable
              columns={columns}
              data={incidentList?.data || []}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              pageNumber={pageNumber}
              pageSize={pageSize}
              totalPages={Math.ceil(incidentList?.total / pageSize)}
              totalRecords={incidentList?.total}
              serverSidePagination={true}
              sorting={sorting}
              onSortingChange={setSorting}
              className="shadow-none border-0"
              tableWrapperClassName="p-0"
            />
          }
        </TabsContent>
      </Tabs>
    </Dialog>
  )
}

export default OutstandingDueDialog;